import React from 'react';
import HunterHeader from './HunterHeader';
import Sidebar from './Sidebar';

const HunterFallback = () => {
    return (
        <React.Fragment>
            <div className="d-flex flex-row">
                <Sidebar />
                <div className="h-content">
                    <HunterHeader />
                </div>
            </div>
        </React.Fragment>
    );
};

export default HunterFallback;
